import PropTypes from "prop-types";
import React from "react";

import { Button2 } from "@/ui2/atoms/Button";

import { createClassNameString } from "../../utils";
import { Text } from "../../Text";

import "./styles.scss";
import { TextTypes } from "../../constants";

export const EmptyProfileInsurance = ({
  className,
  title,
  details,
  onAddButtonClick,
  ...props
}) => (
  <div className={createClassNameString(["apti-EmptyProfileInsurance", className])} {...props}>
    <div className="apti-EmptyProfileInsurance--left">
      <Text type={TextTypes.heading2}>{title}</Text>
      <Text type={TextTypes.paragraph}>{details}</Text>
    </div>

    <Button2 className="tw:min-w-40" onPress={onAddButtonClick}>
      Add
    </Button2>
  </div>
);

EmptyProfileInsurance.propTypes = {
  className: PropTypes.string,
  title: PropTypes.string.isRequired,
  details: PropTypes.string,
  onAddButtonClick: PropTypes.func.isRequired,
};

EmptyProfileInsurance.defaultProps = {
  className: undefined,
  title: "Title",
  details: "Details",
  onAddButtonClick: () => {},
};
